<template>
  <router-view />
</template>

<script>
export default {
  name: 'LayoutAuth'
}
</script>
